/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Home_Banner_On_DescInputs */

const en_simple_home_banner_on_desc = /** @type {(inputs: Simple_Home_Banner_On_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyday language, no technical choices. Start a new plan or continue an existing one.`)
};

const id_simple_home_banner_on_desc = /** @type {(inputs: Simple_Home_Banner_On_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa sehari-hari, tanpa pilihan teknis. Mulai rencana baru atau lanjutkan yang ada.`)
};

/**
* | output |
* | --- |
* | "Everyday language, no technical choices. Start a new plan or continue an existing one." |
*
* @param {Simple_Home_Banner_On_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_home_banner_on_desc = /** @type {((inputs?: Simple_Home_Banner_On_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Home_Banner_On_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_home_banner_on_desc(inputs)
	return en_simple_home_banner_on_desc(inputs)
});